import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  adminLogin,
  adminMe,
  adminLogout,
  setAdminToken,
  getAdminToken,
} from "./adminApi";

const AuthContext = createContext({});

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null: unknown, false: no auth, object: authed
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getAdminToken()) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const me = await adminMe();
      setUser(me);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const data = await adminLogin(email, password);
    setAdminToken(data.access_token);
    setUser({ email: data.user.email, role: "admin" });
    return data;
  };

  const logout = async () => {
    await adminLogout();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AuthContext);

export const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAdminAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-slate-400">
        Vérification de la session...
      </div>
    );
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
};
